import React from 'react';

const SharedButton = ({ onClick, children, className = '', type = 'button' }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`w-full px-6 py-3 bg-[#961914] text-white font-bold rounded-lg shadow-md hover:bg-red-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-75 ${className}`}
    >
      {children}
    </button>
  );
};

export default SharedButton;